<template>
  <article class="home-node-gallery-item">
    <a :href="url">
      <img loading="lazy" :alt="node.name" width="180" height="180" :src="node.imageUrl" class="node-image"/>
      <div class="node-name">{{ node.name }}</div>
    </a>
  </article>
</template>
<script>
export default {
  name: 'NodeGalleryItem',
  props: {
    node: {
      type: Object,
      required: false //true when rdy
    }
  },
  computed: {
    url() {
      return `${process.env.INSIGHTS_V1_HOST}/?id=${this.node.id}&adjectives=any&interstitial=1`;
    }
  }
};
</script>
<style lang="postcss">
.home-node-gallery-item {
  @apply flex flex-col items-center cursor-pointer;
  overflow: visible;
  transition: transform .3s;
  -webkit-transform: translate3d(0, 0, 0);

  a,
  a:hover,
  a:focus,
  a:active {
    all: unset;
  }

  &:hover {
    @media only screen and (min-width: 1300px) {
      transform: scale(1.2);
    }
    transform: scale(0.98);
    z-index: 10;
  }

  .node-image {
    filter: drop-shadow(5px 10px 5px rgba(0, 0, 0, 0.25));
    border-radius: 5px;
    margin-bottom: 10px;
    overflow: hidden;
    @media only screen and (min-width: 1300px) {
      filter: drop-shadow(5px 5px 15px rgba(0, 0, 0, 0.25));
    }

    &:after {
      content: '';
      @apply absolute block top-0 left-0 right-0 bottom-0;
      background-color: #F3F3F3;
      border: 1px solid #CECECE;
      box-sizing: border-box;
      box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.25);
      border-radius: 5px;
      overflow: hidden;

    }
  }

  .node-name {
    font-family: Roboto Condensed, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    max-width: 180px;

    color: #000000;
    margin-right: 10px;
  }
}

</style>